export let cn = [{
            "COLUMN_NAME": "id",
            "column_comment": "订单id"
        },
        {
            "COLUMN_NAME": "order_name",
            "column_comment": "任务名称"
        },
        {
            "COLUMN_NAME": "order_describe",
            "column_comment": "订单描述"
        },
        {
            "COLUMN_NAME": "order_type",
            "column_comment": "订单类型"
        },
        {
            "COLUMN_NAME": "release_type",
            "column_comment": "发布方式"
        },
        {
            "COLUMN_NAME": "release_pattern",
            "column_comment": "发布模式"
        },
        {
            "COLUMN_NAME": "settlement_account_id",
            "column_comment": "结算账套id"
        },
        {
            "COLUMN_NAME": "supplier_id",
            "column_comment": "供应商id"
        },
        {
            "COLUMN_NAME": "enterprise_id",
            "column_comment": "企业id"
        },
        {
            "COLUMN_NAME": "release_time",
            "column_comment": "发布时间"
        },
        {
            "COLUMN_NAME": "create_date_time",
            "column_comment": "创建时间"
        },
        {
            "COLUMN_NAME": "performance_fees",
            "column_comment": "应发供应商绩效费（含税）"
        },
        {
            "COLUMN_NAME": "delivery_time",
            "column_comment": "交付时间"
        },
        {
            "COLUMN_NAME": "order_status",
            "column_comment": "订单状态"
        },
        {
            "COLUMN_NAME": "settlement_price",
            "column_comment": "结算价格"
        },
        {
            "COLUMN_NAME": "order_number",
            "column_comment": "订单号"
        },
        {
            "COLUMN_NAME": "order_credentials",
            "column_comment": "凭证"
        },
        {
            "COLUMN_NAME": "order_coefficient",
            "column_comment": "订单系数"
        },
        {
            "COLUMN_NAME": "performancefees_coefficient",
            "column_comment": "绩效系数"
        },
		{
		            "COLUMN_NAME": "id",
		            "column_comment": "供应商id"
		        },
		        {
		            "COLUMN_NAME": "affiliated_company",
		            "column_comment": "所属企业"
		        },
		        {
		            "COLUMN_NAME": "serial_number",
		            "column_comment": "供应商编号"
		        },
		        {
		            "COLUMN_NAME": "supplier_phone",
		            "column_comment": "手机号码"
		        },
		        {
		            "COLUMN_NAME": "supplier_name",
		            "column_comment": "供应商名称"
		        },
		        {
		            "COLUMN_NAME": "settlement_account_id",
		            "column_comment": "结算账套id"
		        },
		        {
		            "COLUMN_NAME": "certification_status",
		            "column_comment": "认证状态"
		        },
		        {
		            "COLUMN_NAME": "work_status",
		            "column_comment": "工作状态"
		        },
		        {
		            "COLUMN_NAME": "sumbit_time",
		            "column_comment": "申请时间"
		        },
		        {
		            "COLUMN_NAME": "supplier_area",
		            "column_comment": "地区"
		        },
		        {
		            "COLUMN_NAME": "supplier_detail_address",
		            "column_comment": "详细地址"
		        },
		        {
		            "COLUMN_NAME": "business_entity",
		            "column_comment": "经营主体"
		        },
		        {
		            "COLUMN_NAME": "id_card_img",
		            "column_comment": "身份证图片"
		        },
		        {
		            "COLUMN_NAME": "id_card_number",
		            "column_comment": "身份证号码"
		        },
		        {
		            "COLUMN_NAME": "contract",
		            "column_comment": "合同文件地址"
		        },
		        {
		            "COLUMN_NAME": "supplier_id",
		            "column_comment": ""
		        }
		
		]